import { fileExtensionsMapper } from "../../../components-fabric/_defaults/file-extensions-mapper";

export const colFileExtension = {
  classes: "w-10",
  dataField: "fileName",
  formatter: (cell: any) => {
    const extension: string | undefined =
      fileExtensionsMapper[cell ? cell.split(".").pop() : ""];
    return extension ? extension : cell ? `.${cell.split(".").pop()}` : "";
  },
  sort: false,
  text: "Extension",
};
